import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { LanguageService } from '@services/language.service';

import { TranslateModule } from '@ngx-translate/core';
import { SwitcherLanguageComponent } from '@component/switcher-language/switcher-language.component';
import { MobileMenuItemComponent } from './mobile-menu/mobile-menu-item/mobile-menu-item.component';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { PermissionsEnum } from '@enums/permissions.enum';
import { NgxPermissionsService } from 'ngx-permissions';
import {
  fromEvent,
  interval,
  mapTo,
  merge,
  startWith,
  Subscription,
} from 'rxjs';
import { UpdateService } from '@services/update.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { AppDetailsDialogComponentComponent } from '@component/app-details-dialog/app-details-dialog-component.component';
export interface MobileMenuItemInputs {
  label: string;
  icon: string;
  route: string;
  permission: boolean;
  clickCallback?: () => void;
}
@Component({
  selector: 'app-admin',
  imports: [
    MatSidenavModule,
    TranslateModule,
    MatMenuModule,
    RouterModule,
    SwitcherLanguageComponent,
    MatButtonModule,
    MatIconModule,
    MobileMenuItemComponent,
    MatIcon,
  ],
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
})
export class AdminComponent implements OnInit, OnDestroy {
  permissionCompanies = false;
  permissionAppointments = false;
  permissionPayments = false;
  permissionPatients = false;
  permissionUsers = false;
  permissionEmployees = false;
  permissionSuppliers = false;
  permissionPlans = false;
  permissionSubscriptions = false;
  permissionMetsTests = false;
  showReload = false;
  private subs = new Subscription();
  currentTime = '';

  private async checkUserPermission() {
    this.permissionCompanies = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_COMPANY
    );
    this.mobileMenuItems.find(
      (item) => item.label === 'Companies'
    )!.permission = this.permissionCompanies;

    this.permissionAppointments = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_APPOINTMENT
    );
    this.mobileMenuItems.find(
      (item) => item.label === 'Appointments'
    )!.permission = this.permissionAppointments;

    this.permissionSuppliers = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_SUPPLIER
    );
    this.mobileMenuItems.find(
      (item) => item.label === 'Suppliers'
    )!.permission = this.permissionSuppliers;

    this.permissionPayments = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_PAYMENT
    );
    this.mobileMenuItems.find((item) => item.label === 'Payments')!.permission =
      this.permissionPayments;

    this.permissionPatients = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_CLIENT
    );
    this.mobileMenuItems.find((item) => item.label === 'Patients')!.permission =
      this.permissionPatients;

    this.permissionUsers = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_USER
    );
    this.mobileMenuItems.find((item) => item.label === 'Users')!.permission =
      this.permissionUsers;

    this.permissionPlans = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_PLAN
    );
    this.mobileMenuItems.find((item) => item.label === 'Plans')!.permission =
      this.permissionUsers;

    this.permissionSubscriptions = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_SUBSCRIPTION
    );
    this.mobileMenuItems.find(
      (item) => item.label === 'Subscriptions'
    )!.permission = this.permissionUsers;

    this.permissionEmployees = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_USER_COMPANY
    );

    this.mobileMenuItems.find(
      (item) => item.label === 'MetaTests'
    )!.permission = this.permissionUsers;

    this.permissionMetsTests = await this.permissionService.hasPermission(
      PermissionsEnum.INDEX_META_TEST
    );
    this.mobileMenuItems.find(
      (item) => item.label === 'Employees'
    )!.permission = this.permissionEmployees;
  }
  mobileMenuItems: MobileMenuItemInputs[] = [
    // {
    //   label: 'Dashboard',
    //   icon: 'assets/new-icons/menu.svg',
    //   route: 'dashboard',
    //   permission: true,
    // },
    {
      label: 'Companies',
      icon: 'assets/new-icons/menu.svg',
      route: 'companies',
      permission: false,
    },
    {
      label: 'Appointments',
      icon: 'assets/new-icons/menu.svg',
      route: 'appointments',
      permission: false,
    },
    {
      label: 'MetaTests',
      icon: 'assets/new-icons/menu.svg',
      route: 'meta-tests',
      permission: false,
    },
    {
      label: 'Payments',
      icon: 'assets/new-icons/menu.svg',
      route: 'payments',
      permission: false,
    },
    {
      label: 'Patients',
      icon: 'assets/new-icons/menu.svg',
      route: 'patients',
      permission: false,
    },
    {
      label: 'Profile',
      icon: 'assets/new-icons/menu.svg',
      route: 'profile',
      permission: true,
    },
    {
      label: 'Users',
      icon: 'assets/new-icons/menu.svg',
      route: 'users',
      permission: false,
    },
    {
      label: 'Employees',
      icon: 'assets/new-icons/menu.svg',
      route: 'employees',
      permission: false,
    },
    {
      label: 'Employees',
      icon: 'assets/new-icons/menu.svg',
      route: 'employees',
      permission: false,
    },
    {
      label: 'Suppliers',
      icon: 'assets/new-icons/menu.svg',
      route: 'suppliers',
      permission: false,
    },
    {
      label: 'Plans',
      icon: 'assets/new-icons/menu.svg',
      route: 'plans',
      permission: false,
    },
    {
      label: 'Subscriptions',
      icon: 'assets/new-icons/menu.svg',
      route: 'subscriptions',
      permission: false,
    },
    // {
    //   label: 'Logout',
    //   icon: 'assets/new-icons/menu-logout.svg',
    //   route: '',
    //   permission: true,
    //   clickCallback: () => {
    //     this.authService.logout();
    //   },
    // },
  ];
  constructor(
    public language: LanguageService,
    private authService: AuthService,
    private permissionService: NgxPermissionsService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private updates: UpdateService,
    private location: Location,
    public dialog: MatDialog
  ) {
    this.checkUserPermission().then();
  }
  isOnline = navigator.onLine;
  private onlineSub?: Subscription;

  ngOnInit(): void {
    // stream that emits true on 'online' and false on 'offline'
    const online$ = fromEvent(window, 'online').pipe(mapTo(true));
    const offline$ = fromEvent(window, 'offline').pipe(mapTo(false));

    this.onlineSub = merge(online$, offline$)
      .pipe(startWith(this.isOnline))
      .subscribe((status) => {
        this.isOnline = status;
        this.cdr.markForCheck(); // ensure view updates in OnPush scenarios
      });

    this.subs.add(
      this.updates.updateAvailable$.subscribe(() => {
        this.showReload = true;
        this.cdr.markForCheck();
      })
    );

    this.subs.add(
      interval(1000)
        .pipe(startWith(0))
        .subscribe(() => {
          this.currentTime = new Date().toLocaleString();
          this.cdr.markForCheck();
        })
    );
  }

  reloadApp() {
    this.updates.activateAndReload();
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.onlineSub?.unsubscribe();
  }
  userProfile() {
    this.router.navigate(['profile']);
  }

  logout() {
    this.authService.logout();
  }
  get pageName() {
    const url = decodeURIComponent(this.router.url);
    const removedSlash = url.substring(1);
    const firstSegment = removedSlash.split('/')[0];
    const formattedTitle = firstSegment
      .split('-')
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join(' ');
    return formattedTitle;
  }
  appVersion() {
    this.dialog.open(AppDetailsDialogComponentComponent, {});
  }
  goBack() {
    this.location.back();
  }
}
